import { CheckIcon } from "./CheckIcon";

/** Each benefit is a bold lead-in followed by lighter supporting text. */
const BENEFITS = [
  { lead: "Bookkeeping setup done correctly", rest: " from day one" },
  { lead: "Clear management accounts", rest: " to track business performance" },
  {
    lead: "Audit-ready records",
    rest: " to make year-end audit and tax filing smoother and faster",
  },
];

/**
 * The three accounting benefits, identical on the register and manage branches'
 * accounting screens.
 *
 * Three across only from lg: at 640px each column gets ~180px for a bold
 * lead-in plus a trailing clause, which shreds the lines.
 */
export function AccountingBenefits() {
  return (
    <ul className="flex w-full flex-col gap-4 sm:gap-6 lg:flex-row lg:items-start">
      {BENEFITS.map((benefit) => (
        <li key={benefit.lead} className="flex flex-1 items-start gap-[10px]">
          <CheckIcon className="relative block h-6 w-6 shrink-0" />
          <p className="flex-1 font-inter text-sm leading-[19.6px]">
            <span className="font-bold text-[#F3F4F6]">{benefit.lead}</span>
            <span className="text-[#9CA3AF]">{benefit.rest}</span>
          </p>
        </li>
      ))}
    </ul>
  );
}
